import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { staffRegister } from '../services/authService';
import { useAuth } from '../contexts/AuthContext';

/**
 * Staff-assisted signup page (the secret link /staff-signup?k=<secret>). Staff enter the customer's
 * details, an account is created flagged staff_assisted, and the staff member is logged in AS the
 * customer to complete onboarding on their behalf. On completion the customer gets the welcome
 * WhatsApp with a login link that routes them to set their own password.
 */
export default function StaffSignup() {
  const [params] = useSearchParams();
  const secret = params.get('k') || '';
  const navigate = useNavigate();
  const { login } = useAuth();

  const [form, setForm] = useState({ name: '', email: '', mobileNumber: '' });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const update = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    const res = await staffRegister({ ...form, secret });
    setSubmitting(false);

    if (res.success) {
      // Update in-memory auth state (cookie + cache already set by staffRegister) so the router
      // treats this tab as the logged-in customer, then go to onboarding — no refresh needed.
      login(res.userData);
      navigate('/onboarding');
    } else {
      setError(res.message || 'Could not create the account.');
    }
  };

  const wrap = { maxWidth: 420, margin: '60px auto', padding: 24, fontFamily: 'Arial, sans-serif', color: '#111' };
  // Explicit border/background so the inputs stay visible regardless of the app's global CSS.
  const input = {
    display: 'block',
    width: '100%',
    padding: '10px 12px',
    margin: '6px 0 16px',
    boxSizing: 'border-box',
    border: '1px solid #cbd5e1',
    borderRadius: 6,
    background: '#fff',
    color: '#111',
    fontSize: 16,
  };
  const button = { background: '#4F46E5', color: 'white', padding: '12px 20px', border: 'none', borderRadius: 5, cursor: 'pointer', width: '100%', fontSize: 16 };

  if (!secret) {
    return (
      <div style={wrap}>
        <h2>Staff sign-up</h2>
        <p>This link is missing its access code. Please use the full staff sign-up link.</p>
      </div>
    );
  }

  return (
    <div style={wrap}>
      <h2>Sign up a customer</h2>
      <p>Create the account, then you'll continue into onboarding on the customer's behalf.</p>
      <form onSubmit={onSubmit}>
        <label>Parent name
          <input style={input} type="text" value={form.name} onChange={update('name')} required />
        </label>
        <label>Email
          <input style={input} type="email" value={form.email} onChange={update('email')} required />
        </label>
        <label>Mobile number
          <input style={input} type="tel" value={form.mobileNumber} onChange={update('mobileNumber')} required />
        </label>
        {error && <p style={{ color: '#b00020' }}>{error}</p>}
        <button style={button} type="submit" disabled={submitting}>
          {submitting ? 'Creating…' : 'Create account & start onboarding'}
        </button>
      </form>
    </div>
  );
}
